import React from "react";
import {
  Box,
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Stack,
  Divider,
  useTheme,
} from "@mui/material";
import ImageOrderingEditor, {
  ImageOrderingValue,
} from "../ImageOrderingEditor";
import SyndicatorCard from "../SyndicatorCard";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

export const reynoldsDefaults = {
  syndicatorData: {
    dealerID: "",
    includePanoIframe: false,
  },
  imageOrdering: {
    ImageOrder: "",
  },
};

const ReynoldsForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const accent = theme.palette.status.accent;

  const syndicatorData = config.syndicatorData || {};
  const imageOrdering: ImageOrderingValue = config.imageOrdering || {};

  return (
    <SyndicatorCard title="Reynolds Configuration">
      <Stack spacing={3}>
        <Box>
          <Typography
            variant="subtitle2"
            sx={{ mb: 1.5, color: accent, fontWeight: 600 }}
          >
            Syndicator Data
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Dealer ID"
                fullWidth
                size="small"
                value={syndicatorData.dealerID || ""}
                onChange={(e) =>
                  onChange("syndicatorData.dealerID", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={syndicatorData.includePanoIframe ?? false}
                    onChange={(e) =>
                      onChange(
                        "syndicatorData.includePanoIframe",
                        e.target.checked,
                      )
                    }
                  />
                }
                label={
                  <Typography sx={{ fontWeight: 500 }}>
                    Include Pano Iframe
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </Box>

        <Divider />

        <Box>
          <Typography
            variant="subtitle2"
            sx={{ mb: 1.5, color: accent, fontWeight: 600 }}
          >
            Image Ordering
          </Typography>
          <ImageOrderingEditor
            value={imageOrdering}
            onChange={(next) => onChange("imageOrdering", next)}
          />
        </Box>
      </Stack>
    </SyndicatorCard>
  );
};

export default ReynoldsForm;
